import React from "react"

import { TResolvedHighlightedContent } from "@/lib/kontent/components/getHighlightedContent"

import { HighlightedContent } from "./HighlightedContent"

type THighlightedContentResolverProps = {
  resolvedData: TResolvedHighlightedContent
  variant: "article" | "component"
}

const HighlightedContentResolver = ({
  resolvedData,
  variant,
}: THighlightedContentResolverProps) => {
  const kontentData = {
    title: resolvedData.title,
    content: resolvedData.content,
    icon: resolvedData.icon,
    isInArticle: variant === "article",
  }
  return <HighlightedContent {...kontentData} />
}

export { HighlightedContentResolver, type THighlightedContentResolverProps }
